// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x6lFh721BnEECcup {
  flex-direction: column;
}

.x6lFh721BnEECcup, .XMQEpzHqgNAVcvWV {
  gap: var(--lp-spacing-200);
  display: flex;
}

.XMQEpzHqgNAVcvWV {
  flex-wrap: wrap;
}

.tiijX5ayR4bON0k2 {
  border-radius: var(--lp-border-radius-medium);
  align-items: center;
  gap: var(--lp-spacing-200);
  padding: 0 var(--lp-spacing-200);
  outline: none;
  display: flex;
}

.tiijX5ayR4bON0k2[data-focus-visible] {
  outline: 2px solid var(--lp-color-shadow-interactive-focus);
  outline-offset: -2px;
  z-index: 1;
}

.tiijX5ayR4bON0k2[data-disabled] {
  border-color: var(--lp-color-border-interactive-disabled);
  color: var(--lp-color-text-interactive-disabled);
}

.tiijX5ayR4bON0k2[data-selection-mode="multiple"] {
  background-color: var(--lp-color-bg-interactive-secondary-base);
  border: 1px solid var(--lp-color-border-interactive-secondary-base);
}

.tiijX5ayR4bON0k2[data-selected] {
  background-color: var(--lp-color-bg-interactive-selected);
  border-color: var(--lp-color-border-interactive-selected);
  color: var(--lp-color-text-interactive-selected);
}

.tiijX5ayR4bON0k2[data-allows-removing] {
  padding-right: 0;
}

.RWOHy3zRPVAPJS8U {
  font: var(--lp-text-label-2-medium);
  height: var(--lp-size-20);
}

.RWOHy3zRPVAPJS8U [slot="remove"] {
  height: var(--lp-size-20);
  width: var(--lp-size-20);
  background-color: #0000;
}

.RWOHy3zRPVAPJS8U [slot="remove"][data-hovered] {
  background-color: #0000;
}

[data-lp-hit-area=expanded] .RWOHy3zRPVAPJS8U [slot="remove"]:before {
  inset: calc(var(--lp-spacing-200)*-1);
}

.S5eBRavWa0swtVRh {
  font: var(--lp-text-label-1-medium);
  height: var(--lp-size-24);
}

.CEmFRmP3wkbA5zbn {
  background-color: var(--lp-color-bg-ui-tertiary);
  color: var(--lp-color-text-ui-secondary);
}

.Cd76HODB14Qmk5rt {
  background-color: var(--lp-color-bg-feedback-success);
  color: var(--lp-color-text-feedback-success);
}

.knxrjRNQrcnYYMgF {
  background-color: var(--lp-color-bg-feedback-error);
  color: var(--lp-color-text-feedback-error);
}

.DlZ99SFbpJsbkppy {
  background-color: var(--lp-color-bg-feedback-warning);
  color: var(--lp-color-text-feedback-warning);
}

.yNiD6u1i404P7lSs {
  background-color: var(--lp-color-bg-product-beta);
  color: var(--lp-color-text-product-beta);
}

.tLNBNOqArPkE6AKV {
  background-color: var(--lp-color-bg-product-federal);
  color: var(--lp-color-text-product-federal);
}

.czr6ZYCRZIU3nNI1 {
  background-color: var(--lp-color-bg-feedback-success);
  color: var(--lp-color-text-feedback-success);
}

.CT6qeeM2OWMYDTYc {
  background-color: var(--lp-color-bg-feedback-info);
  color: var(--lp-color-text-feedback-info);
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/components/src/styles/TagGroup.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,6CAA6C;EAC7C,mBAAmB;EACnB,0BAA0B;EAC1B,gCAAgC;EAChC,aAAa;EACb,aAAa;AACf;;AAEA;EACE,2DAA2D;EAC3D,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,yDAAyD;EACzD,gDAAgD;AAClD;;AAEA;EACE,+DAA+D;EAC/D,mEAAmE;AACrE;;AAEA;EACE,yDAAyD;EACzD,yDAAyD;EACzD,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;EACE,mDAAmD;EACnD,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;EACE,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;EACpD,2CAA2C;AAC7C;;AAEA;EACE,qDAAqD;EACrD,4CAA4C;AAC9C;;AAEA;EACE,kDAAkD;EAClD,yCAAyC;AAC3C","sourcesContent":[".group {\n  flex-direction: column;\n}\n\n.group, .list {\n  gap: var(--lp-spacing-200);\n  display: flex;\n}\n\n.list {\n  flex-wrap: wrap;\n}\n\n.tag {\n  composes: selectable from \"./base.module.css\";\n  border-radius: var(--lp-border-radius-medium);\n  align-items: center;\n  gap: var(--lp-spacing-200);\n  padding: 0 var(--lp-spacing-200);\n  outline: none;\n  display: flex;\n}\n\n.tag[data-focus-visible] {\n  outline: 2px solid var(--lp-color-shadow-interactive-focus);\n  outline-offset: -2px;\n  z-index: 1;\n}\n\n.tag[data-disabled] {\n  border-color: var(--lp-color-border-interactive-disabled);\n  color: var(--lp-color-text-interactive-disabled);\n}\n\n.tag[data-selection-mode=\"multiple\"] {\n  background-color: var(--lp-color-bg-interactive-secondary-base);\n  border: 1px solid var(--lp-color-border-interactive-secondary-base);\n}\n\n.tag[data-selected] {\n  background-color: var(--lp-color-bg-interactive-selected);\n  border-color: var(--lp-color-border-interactive-selected);\n  color: var(--lp-color-text-interactive-selected);\n}\n\n.tag[data-allows-removing] {\n  padding-right: 0;\n}\n\n.small {\n  font: var(--lp-text-label-2-medium);\n  height: var(--lp-size-20);\n}\n\n.small [slot=\"remove\"] {\n  height: var(--lp-size-20);\n  width: var(--lp-size-20);\n  background-color: #0000;\n}\n\n.small [slot=\"remove\"][data-hovered] {\n  background-color: #0000;\n}\n\n:global([data-lp-hit-area=expanded]) .small [slot=\"remove\"]:before {\n  inset: calc(var(--lp-spacing-200)*-1);\n}\n\n.medium {\n  font: var(--lp-text-label-1-medium);\n  height: var(--lp-size-24);\n}\n\n.default {\n  background-color: var(--lp-color-bg-ui-tertiary);\n  color: var(--lp-color-text-ui-secondary);\n}\n\n.success {\n  background-color: var(--lp-color-bg-feedback-success);\n  color: var(--lp-color-text-feedback-success);\n}\n\n.error {\n  background-color: var(--lp-color-bg-feedback-error);\n  color: var(--lp-color-text-feedback-error);\n}\n\n.warning {\n  background-color: var(--lp-color-bg-feedback-warning);\n  color: var(--lp-color-text-feedback-warning);\n}\n\n.beta {\n  background-color: var(--lp-color-bg-product-beta);\n  color: var(--lp-color-text-product-beta);\n}\n\n.federal {\n  background-color: var(--lp-color-bg-product-federal);\n  color: var(--lp-color-text-product-federal);\n}\n\n.new {\n  background-color: var(--lp-color-bg-feedback-success);\n  color: var(--lp-color-text-feedback-success);\n}\n\n.info {\n  background-color: var(--lp-color-bg-feedback-info);\n  color: var(--lp-color-text-feedback-info);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group": `x6lFh721BnEECcup`,
	"list": `XMQEpzHqgNAVcvWV`,
	"tag": `tiijX5ayR4bON0k2 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["selectable"]}`,
	"small": `RWOHy3zRPVAPJS8U`,
	"medium": `S5eBRavWa0swtVRh`,
	"default": `CEmFRmP3wkbA5zbn`,
	"success": `Cd76HODB14Qmk5rt`,
	"error": `knxrjRNQrcnYYMgF`,
	"warning": `DlZ99SFbpJsbkppy`,
	"beta": `yNiD6u1i404P7lSs`,
	"federal": `tLNBNOqArPkE6AKV`,
	"new": `czr6ZYCRZIU3nNI1`,
	"info": `CT6qeeM2OWMYDTYc`
};
export default ___CSS_LOADER_EXPORT___;
